import { Routes, CanActivate } from '@angular/router';

// Layouts
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';
import { AuthGuardService as AuthGuard } from './core/guards/auth-guard.service';
import { AuthRoleGuardService as RoleGuard } from './core/guards/auth-role-guard.service';
import { RedirectComponent } from './extras/redirect/redirect.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: CommonLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        //redirectTo: 'dashboard',
        component: RedirectComponent,
        //redirectTo: 'msop/customers',
        pathMatch: 'full',
      },
      {
        path: 'redmine',
        loadChildren:
          './redmine-connect/redmine-connect.routing.module#RedmineConnectRoutingModule',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber'] },
      },
      {
        path: 'campaigns',
        loadChildren: './campaigns/campaigns.modules#CampaignsModules',
        canActivate: [RoleGuard],
        data: { blockedRoles: ['agent'] },
      },
      {
        path: 'reports',
        loadChildren: './reports/reports.modules#ReportsModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['admin', 'sales'] },
      },
      {
        path: 'audience',
        loadChildren: './audience/audience.modules#AudienceModules',
        canActivate: [AuthGuard],
      },
      {
        path: 'settings',
        loadChildren: './settings/settings.modules#SettingsModules',
        canActivate: [RoleGuard],
        data: { blockedRoles: ['agent'] },
      },
      {
        path: 'admin',
        loadChildren: './admin/admin.modules#AdminModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['admin'] },
      },
      {
        path: 'dms-importing',
        loadChildren:
          './dms-importing/dms-importing.modules#DmsImportingModules',
        canActivate: [RoleGuard],
        data: { blockedRoles: ['agent'] },
      },
      {
        path: 'system-monitoring',
        loadChildren:
          './system-monitoring/system-monitoring.modules#SystemMonitoringModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['admin'] },
      },
      {
        path: 'msop',
        loadChildren: './msop/msop.modules#MsopModules',
        canActivate: [AuthGuard],
      },
      {
        path: 'yp',
        loadChildren: './yellowpages/yellowpages.modules#YellowpagesModules',
        canActivate: [AuthGuard],
      },
      {
        path: 'hubspot',
        loadChildren: './hubspot/hubspot.modules#HubspotModules',
        canActivate: [AuthGuard],
      },
      {
        path: 'elevate',
        loadChildren: './elevate/elevate.modules#ElevateModules',
        canActivate: [AuthGuard],
      },
      {
        path: 'facebook',
        loadChildren: './facebook/facebook.modules#FacebookModule',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['admin', 'agent', 'user'] },
      },
      {
        path: 'robomail',
        loadChildren: './robomail/robomail.modules#RobomailModule',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['admin', 'developer'] },
      },
      {
        path: 'omt',
        loadChildren: './omt/omt.modules#OmtModules',
        canActivate: [RoleGuard],
        //data: {blockedRoles:['agent']}
        data: { expectedRoles: ['admin', 'user', 'agent'] },
      },
      {
        path: 'poc',
        loadChildren: './poc/poc.modules#PocModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber'] },
      },
      {
        path: 'cbr',
        loadChildren: './carbrewer/carbrewer.modules#CarbrewerModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber', 'admin', 'sales'] },
      },
      {
        path: 'matching',
        loadChildren: './matching/matching.modules#MatchingModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber'] },
      },
      {
        path: 'crm',
        loadChildren: './crm/crm.modules#CrmModules',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber'] },
      },
      {
        path: 'playbooks',
        loadChildren: './playbooks/playbooks.module#PlaybooksModule',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['user'] },
      },
      {
        path: 'creatives',
        loadChildren: './creatives/creatives.module#CreativesModule',
        canActivate: [RoleGuard],
        data: { expectedRoles: ['mike-schreiber'] },
      },
    ],
  },
  {
    path: '',
    component: AuthenticationLayoutComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: './extras/authentication.modules#AuthenticationModule',
      },
    ],
  },
];
